import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { canonicalStateGamePath } from "@/lib/game-routing";

export const Route = createFileRoute("/games/$gameSlug")({
  beforeLoad: ({ params, location }) => {
    const canonical = canonicalStateGamePath(params.gameSlug);
    if (!canonical) return;

    // Preserve the sub-path (history / results/$date) so indexed deep links
    // land on the equivalent state-scoped page instead of the game hub.
    const suffix = location.pathname.replace(/\/+$/, "").slice(`/games/${params.gameSlug}`.length);
    const dateMatch = suffix.match(/^\/results\/([^/]+)$/);
    if (dateMatch) {
      throw redirect({
        to: "/$stateSlug/$gameSlug/results/$date",
        params: { ...canonical, date: dateMatch[1] },
        statusCode: 301,
        replace: true,
      });
    }
    if (suffix === "/history") {
      throw redirect({
        to: "/$stateSlug/$gameSlug/history",
        params: canonical,
        search: location.search as never,
        statusCode: 301,
        replace: true,
      });
    }
    throw redirect({ to: "/$stateSlug/$gameSlug", params: canonical, statusCode: 301, replace: true });
  },
  component: () => <Outlet />,
});
